"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotifier = void 0;
const notistack_1 = require("notistack");
const useNotifier = () => {
    const { enqueueSnackbar } = (0, notistack_1.useSnackbar)();
    const showNotification = (message, type = "success") => {
        enqueueSnackbar(message, { variant: type });
    };
    return { showNotification };
};
exports.useNotifier = useNotifier;
